import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

function BarcodeCode128Svg({ style = {width: "300px", height: "180px"}, color = "primary", viewBox = "0 0 612.000000 210.000000" }) {
    return (
        <SvgIcon color={color} style={style} viewBox={viewBox}>
            <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)"
                fill="#000000" stroke="none">
                <path d="M250 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M330 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M410 1220 l0 -880 65 0 65 0 0 880 0 880 -65 0 -65 0 0 -880z"/>
                <path d="M580 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M660 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M830 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M1000 1220 l0 -880 60 0 60 0 0 880 0 880 -60 0 -60 0 0 -880z"/>
                <path d="M1160 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M1330 1220 l0 -880 60 0 60 0 0 880 0 880 -60 0 -60 0 0 -880z"/>
                <path d="M1500 1220 l0 -880 60 0 60 0 0 880 0 880 -60 0 -60 0 0 -880z"/>
                <path d="M1660 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M1750 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M1910 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M2080 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M2160 1220 l0 -880 65 0 65 0 0 880 0 880 -65 0 -65 0 0 -880z"/>
                <path d="M2330 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M2410 1220 l0 -880 65 0 65 0 0 880 0 880 -65 0 -65 0 0 -880z"/>
                <path d="M2660 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M2830 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M2910 1220 l0 -880 65 0 65 0 0 880 0 880 -65 0 -65 0 0 -880z"/>
                <path d="M3080 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M3160 1220 l0 -880 65 0 65 0 0 880 0 880 -65 0 -65 0 0 -880z"/>
                <path d="M3410 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M3490 1220 l0 -880 65 0 65 0 0 880 0 880 -65 0 -65 0 0 -880z"/>
                <path d="M3740 1220 l0 -880 25 0 25 0 0 880 0 880 -25 0 -25 0 0 -880z"/>
                <path d="M3830 1220 l0 -880 60 0 60 0 0 880 0 880 -60 0 -60 0 0 -880z"/>
                <path d="M4080 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M4160 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M4240 1220 l0 -880 65 0 65 0 0 880 0 880 -65 0 -65 0 0 -880z"/>
                <path d="M4490 1220 l0 -880 25 0 25 0 0 880 0 880 -25 0 -25 0 0 -880z"/>
                <path d="M4580 1220 l0 -880 60 0 60 0 0 880 0 880 -60 0 -60 0 0 -880z"/>
                <path d="M4830 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M4910 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M5080 1220 l0 -880 60 0 60 0 0 880 0 880 -60 0 -60 0 0 -880z"/>
                <path d="M5330 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M5410 1220 l0 -880 65 0 65 0 0 880 0 880 -65 0 -65 0 0 -880z"/>
                <path d="M5580 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M5660 1220 l0 -880 65 0 65 0 0 880 0 880 -65 0 -65 0 0 -880z"/>
                <path d="M5830 1220 c0 -873 0 -880 20 -880 20 0 20 7 20 880 0 873 0 880 -20
                880 -20 0 -20 -7 -20 -880z"/>
                <path d="M1538 273 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M1777 269 c-45 -26 -61 -136 -29 -199 49 -98 162 -43 162 78 0 101
                -65 160 -133 121z m77 -32 c36 -27 33 -157 -5 -178 -49 -26 -89 15 -89 92 0
                80 45 121 94 86z"/>
                <path d="M2002 264 c-50 -34 -67 -120 -38 -189 37 -89 166 -66 166 30 0 70
                -83 112 -133 68 -20 -18 -20 -17 -13 12 10 45 43 68 88 62 27 -4 38 -1 38 8 0
                28 -72 34 -108 9z m82 -120 c34 -34 9 -94 -39 -94 -30 0 -55 25 -55 55 0 30
                25 55 55 55 13 0 31 -7 39 -16z"/>
                <path d="M2218 273 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M2453 196 c-69 -110 -69 -116 7 -116 l60 0 0 -30 c0 -20 5 -30 15
                -30 10 0 15 10 15 30 0 23 4 30 20 30 11 0 20 7 20 15 0 8 -9 15 -20 15 -18 0
                -20 7 -20 85 0 81 -1 85 -22 85 -18 0 -35 -19 -75 -84z m64 -83 c-3 -2 -23 -3
                -45 -1 l-41 3 42 67 42 67 3 -66 c2 -36 1 -67 -1 -70z"/>
                <path d="M2668 273 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M2903 196 c-69 -110 -69 -116 7 -116 l60 0 0 -30 c0 -20 5 -30 15
                -30 10 0 15 10 15 30 0 23 4 30 20 30 11 0 20 7 20 15 0 8 -9 15 -20 15 -18 0
                -20 7 -20 85 0 81 -1 85 -22 85 -18 0 -35 -19 -75 -84z m64 -83 c-3 -2 -23 -3
                -45 -1 l-41 3 42 67 42 67 3 -66 c2 -36 1 -67 -1 -70z"/>
                <path d="M3118 273 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M3335 255 c-53 -52 -16 -145 56 -145 18 0 41 8 52 18 20 17 20 16 13
                -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50 34 67
                120 38 189 -25 59 -97 75 -141 30z m99 -21 c34 -34 9 -94 -39 -94 -49 0 -72
                55 -38 92 20 22 56 23 77 2z"/>
                <path d="M3555 255 c-53 -52 -16 -145 56 -145 18 0 41 8 52 18 20 17 20 16 13
                -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50 34 67
                120 38 189 -25 59 -97 75 -141 30z m99 -21 c34 -34 9 -94 -39 -94 -49 0 -72
                55 -38 92 20 22 56 23 77 2z"/>
                <path d="M3785 255 c-53 -52 -16 -145 56 -145 18 0 41 8 52 18 20 17 20 16 13
                -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50 34 67
                120 38 189 -25 59 -97 75 -141 30z m99 -21 c34 -34 9 -94 -39 -94 -49 0 -72
                55 -38 92 20 22 56 23 77 2z"/>
                <path d="M4005 255 c-53 -52 -16 -145 56 -145 18 0 41 8 52 18 20 17 20 16 13
                -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50 34 67
                120 38 189 -25 59 -97 75 -141 30z m99 -21 c34 -34 9 -94 -39 -94 -49 0 -72
                55 -38 92 20 22 56 23 77 2z"/>
                <path d="M4235 255 c-53 -52 -16 -145 56 -145 18 0 41 8 52 18 20 17 20 16 13
                -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50 34 67
                120 38 189 -25 59 -97 75 -141 30z m99 -21 c34 -34 9 -94 -39 -94 -49 0 -72
                55 -38 92 20 22 56 23 77 2z"/>
                <path d="M4463 273 c-7 -2 -13 -11 -13 -18 0 -9 11 -12 39 -8 44 6 81 -10 81
                -35 0 -27 -20 -42 -57 -42 -23 0 -33 -5 -33 -15 0 -10 10 -15 31 -15 62 0 89
                -38 52 -75 -13 -13 -29 -16 -70 -13 -38 3 -53 1 -53 -8 0 -24 75 -33 124 -14
                49 18 61 105 16 117 -18 5 -18 5 1 24 19 19 25 55 11 75 -18 28 -90 43 -129
                27z"/>
                </g>

        </SvgIcon>
    );
}

export default BarcodeCode128Svg;
